// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import UploadNewMedia from '../_raw/ui/icon_upload_new_media.svg';
import withIconProps from '../withIconProps';

export default withIconProps(UploadNewMedia);
